<div class="container-fluid">
  <div class="form-horizontal">
    <h3>{{ 'events.registration.wizard.payment-info.title' | translate | titlecase }}</h3>

    <div class="form-group" *ngIf="registration.IsEdit && hasPaymentOptionFees">
      <div class="col-sm-10 col-md-7">
        <div class="alert alert-danger">
          {{ 'events.registration.wizard.payment-info.payment-option-fee-on-edit-warning' | translate | titlecase }}
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="showPromoCodes()">
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.apply-promo-code-title' | translate | titlecase }}
      </label>
      <div class="col-sm-4">
        <div class="input-group">
          <select class="form-control" [(ngModel)]="selectedPromoCode">
            <option [value]="0">Select a Promo Code</option>
            <option
              *ngFor="let promoCode of eventPromoCodes"
              [value]="promoCode.PromoCodeId"
              [hidden]="hidePromoCode(promoCode.PromoCodeId, promoCode.EventItemIds)"
            >
              {{ promoCode.Name }}
            </option>
          </select>
          <span class="input-group-btn wl-promo-code-apply">
            <button pButton type="button" class="btn btn-default" (click)="applyPromoCode()" [disabled]="selectedPromoCode == 0">
              {{ 'common.apply' | translate | titlecase }}
            </button>
            {{ selectedPromoCode }}
          </span>
        </div>
        <div [hidden]="!showPromoCodeNotStarted" class="text-danger">
          {{ 'events.registration.wizard.payment-info.promo-code-not-started' | translate }}
        </div>
        <div [hidden]="!showPromoCodeExpired" class="text-danger">
          {{ 'events.registration.wizard.payment-info.promo-code-expired' | translate }}
        </div>
        <div [hidden]="!showPromoCodeMaxedOut" class="text-danger">
          {{ 'events.registration.wizard.payment-info.promo-code-maxed-out' | translate }}
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="registration?.PromoCodes?.length">
      <div class="col-sm-offset-6 col-md-offset-3 col-sm-4">
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let promoCode of registration.PromoCodes">
            <button
              pButton
              type="button"
              class="btn btn-xs btn-danger pull-right"
              (click)="removePromoCode(promoCode.PromoCodeId)"
              icon="pi pi-trash"
            ></button>
            {{ promoCode.Name }}:
            <span *ngIf="promoCode.DiscountType == promoCodeDiscountType.Dollar">{{ promoCode.Discount | currency }}</span>
            <span *ngIf="promoCode.DiscountType == promoCodeDiscountType.Percent">{{ promoCode.Discount | atlasPercent }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="form-group" *ngIf="hasBenefitsThatCanBeUsed">
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.use-member-benefits-label' | translate | titlecase }}
      </label>
      <div class="col-sm-4">
        <select class="form-control" [(ngModel)]="selectedEventBenefit.EventBenefitId" (ngModelChange)="onBenefitChange($event)">
          <option [value]="0">{{ 'events.registration.wizard.payment-info.select-a-benefit-label' | translate | titlecase }}</option>
          <option *ngFor="let eventBenefit of availableBenefitsToUse" [value]="eventBenefit.EventBenefitId">
            {{ eventBenefit.BenefitType }}
          </option>
        </select>
      </div>
    </div>
    <div class="form-group" *ngIf="selectedEventBenefit.LimitType == 0 && hasBenefitsThatCanBeUsed">
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.profile-benefits-amount-remaining-label' | translate | titlecase }}
      </label>
      <div class="col-sm-4">
        {{ selectedProfileBenefit.ValueRemaining | currency }}
      </div>
    </div>
    <div class="form-group" *ngIf="selectedEventBenefit.LimitType == 1 && hasBenefitsThatCanBeUsed">
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.profile-benefits-quantity-remaining-label' | translate | titlecase }}
      </label>
      <div class="col-sm-4">
        {{ selectedProfileBenefit.QuantityRemaining }}
      </div>
    </div>

    <div class="form-group" *ngIf="hasBenefitsThatCanBeUsed">
      <div class="col-sm-6 col-md-3 control-label">
        <label class="control-label" *ngIf="selectedEventBenefit.LimitType == 0">
          {{ 'events.registration.wizard.payment-info.benefit-amount-to-use-label' | translate | titlecase }}
        </label>
        <label class="control-label" *ngIf="selectedEventBenefit.LimitType == 1">
          {{ 'events.registration.wizard.payment-info.benefit-quantity-to-use-label' | translate | titlecase }}
        </label>
      </div>

      <div class="col-sm-4">
        <div class="input-group">
          <input
            type="number"
            class="form-control text-right"
            [(ngModel)]="selectedRegistrationBenefit.ValueToApply"
            [step]="0.01"
            *ngIf="selectedEventBenefit.LimitType == 0"
            placeholder="0.0"
            (ngModelChange)="onBenefitAmountToApplyChange($event)"
          />
          <input
            type="number"
            class="form-control text-right"
            [(ngModel)]="selectedRegistrationBenefit.QuantityToApply"
            [step]="1"
            *ngIf="selectedEventBenefit.LimitType == 1"
            placeholder="0"
            (ngModelChange)="onBenefitQuantityToApplyChange($event)"
          />
          <span class="input-group-btn">
            <button pButton type="button" class="btn btn-default" (click)="applyBenefit()">
              {{ 'common.apply' | translate | titlecase }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              *ngIf="registration.Registration.BenefitsToApplyTotal > 0"
              (click)="removeBenefits()"
            >
              {{ 'common.remove' | translate | titlecase }}
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="form-group" *ngFor="let eventItemTotal of registration.Registration.EventItemTotals">
      <div class="col-xm-12">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6 col-md-3 text-right text-left-xs">
              {{ eventItemTotal.EventItem.Descr }}:
              <div>
                {{ eventItemTotal.EventItem.Quantity }} x
                {{
                  ((registration.Registration.ForceMemberPricing || registration.Registration.IsMember) &&
                  eventItemTotal.EventItem.HasMemberPricing
                    ? eventItemTotal.EventItem.MemberPrice
                    : eventItemTotal.EventItem.NonMemberPrice
                  ) | currency
                }}
              </div>
            </div>
            <div class="col-sm-4 text-right text-left-xs">
              {{ eventItemTotal.ItemTotal | currency }}
            </div>
          </div>
          <div class="row" *ngIf="eventItemTotal.AdditionalCost > 0">
            <div class="col-sm-6 col-md-3 text-right text-left-xs">
              {{ 'events.registration.wizard.payment-info.additional-cost' | translate | titlecase }}
            </div>
            <div class="col-sm-4 text-right text-left-xs">
              {{ eventItemTotal.AdditionalCost | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'common.revenue.amount' | translate | titlecase }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        {{ registration.Registration.PreTaxPreDiscountAmount | currency }}
      </div>
    </div>
    <div class="row" *ngIf="registration?.PromoCodes?.length">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'events.registration.wizard.payment-info.promo-codes-applied' | translate | titlecase }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">-{{ registration.Registration.DiscountTotal | currency }}</div>
    </div>
    <div class="row" *ngIf="registration.Registration.BenefitsToApplyTotal > 0">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'events.registration.wizard.payment-info.benefit-to-use-summary-label' | translate | titlecase }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">-{{ registration.Registration.BenefitsToApplyTotal | currency }}</div>
    </div>
    <div class="row">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'common.revenue.tax' | translate | titlecase }}&nbsp;{{ 'common.revenue.amount' | translate | titlecase }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        {{ registration.Registration.TaxAmount | currency }}
      </div>
    </div>

    <!--<div class="row" [hidden]="registration.Registration.BenefitsPreviouslyAppliedTotal <= 0">
            <div class="col-sm-6 col-md-3 text-right text-left-xs">
                {{'events.registration.wizard.payment-info.previous-benefits-used-summary-label'|translate|titlecase}}
            </div>
            <div class="col-sm-4 text-right text-left-xs">
                {{registration.Registration.BenefitsPreviouslyAppliedTotal|currency}}
            </div>
        </div>-->

    <div class="row" [hidden]="registration.Registration.ExistingPaymentOptionFees <= 0">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'events.registration.wizard.payment-info.existing-payment-method-fee-label' | translate | titlecase }}&nbsp;{{
          'common.revenue.amount' | translate | titlecase
        }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        {{ registration.Registration.ExistingPaymentOptionFees | currency }}
      </div>
    </div>

    <div class="row" [hidden]="registration.Registration.PaymentOptionFeeAmount <= 0">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'events.registration.wizard.payment-info.payment-option-fee-text' | translate | titlecase }}&nbsp;{{
          'common.revenue.amount' | translate | titlecase
        }}&nbsp;{{ registration.Registration.SelectedPaymentMethod?.Descr | titlecase }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        {{ registration.Registration.PaymentOptionFeeAmount | currency }}
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        <strong>{{ 'common.revenue.total' | translate | titlecase }}&nbsp;{{ 'common.revenue.amount' | translate | titlecase }}</strong>
      </div>
      <div class="col-sm-4 text-right text-left-xs wc-event-reg-wiz-payment-info-total">
        <b>{{ registration.Registration.TotalAmount | currency }}</b>
      </div>
    </div>

    <div class="form-group" *ngIf="registration.IsEdit">
      <div class="col-sm-10">
        <hr />
      </div>
    </div>

    <div class="form-group" [hidden]="!registration.IsEdit">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        {{ 'events.registration.wizard.payment-info.already-paid-label' | translate | titlecase }}&nbsp;{{
          'common.revenue.amount' | translate | titlecase
        }}
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        {{ registration.Registration.AlreadyPaidAmountForEdit | currency }}
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-6 col-md-3 text-right text-left-xs">
        <label *ngIf="!registration.IsEdit">
          {{ 'events.registration.wizard.payment-info.payment-option-label' | translate | titlecase }}
        </label>

        <label *ngIf="registration.IsEdit">
          {{ 'events.registration.wizard.payment-info.payment-option-previous-payment-option-label' | translate | titlecase }}
        </label>
      </div>
      <div class="col-sm-4 text-right text-left-xs">
        <select
          [(ngModel)]="registration.Registration.PaymentOption"
          class="form-control"
          [disabled]="registration.IsEdit"
          (ngModelChange)="onPaymentOptionChange($event)"
        >
          <option
            *ngFor="let paymentMethod of paymentMethods"
            [value]="paymentMethod.PaymentMethodId"
            [selected]="paymentMethod.PaymentMethodId == registration.Registration.PaymentOption ? true : null"
          >
            {{ paymentMethod.Descr }}
          </option>
        </select>
      </div>
    </div>

    <hr *ngIf="registration.IsEdit && registration.Registration.AdditionalPaymentAmountForEdit > 0" />

    <div class="form-group" *ngIf="registration.IsEdit && registration.Registration.AdditionalPaymentAmountForEdit > 0">
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.additional-payment-label' | translate | titlecase }}&nbsp;{{
          'common.revenue.amount' | translate | titlecase
        }}
      </label>
      <div class="col-sm-4 text-right text-left-xs">
        <strong>{{ registration.Registration.AdditionalPaymentAmountForEdit | currency }}</strong>
      </div>
    </div>

    <div class="form-group" *ngIf="registration.IsEdit && registration.Registration.AdditionalPaymentAmountForEdit > 0">
      <label class="col-sm-6 col-md-3 control-label">
        <span *ngIf="!registration.IsEdit">
          {{ 'events.registration.wizard.payment-info.payment-option-label' | translate | titlecase }}
        </span>
        <span *ngIf="registration.IsEdit">
          {{ 'events.registration.wizard.payment-info.payment-option-on-edit-label' | translate | titlecase }}
        </span>
      </label>
      <div class="col-sm-4 text-right text-left-xs">
        <select
          [(ngModel)]="registration.Registration.PaymentOptionForEdit"
          [disabled]="registration.Registration.AdditionalPaymentAmountForEdit <= 0"
          class="form-control"
          (ngModelChange)="onPaymentOptionChange($event)"
        >
          <option
            *ngFor="let paymentMethod of paymentMethods"
            [value]="paymentMethod.PaymentMethodId"
            [selected]="paymentMethod.PaymentMethodId == registration.Registration.PaymentOptionForEdit ? true : null"
          >
            {{ paymentMethod.Descr }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
      <div class="col-sm-offset-6 col-md-offset-3 col-sm-6 col-md-8">
        <label>
          <input type="checkbox" [(ngModel)]="registration.Registration.Paid" />
          <span>
            {{ 'events.registration.wizard.payment-info.mark-as-paid-label' | translate | titlecase }}
          </span>
        </label>
        <label>
          <input type="checkbox" [(ngModel)]="registration.Registration.Comp" />
          <span>
            {{ 'events.registration.wizard.payment-info.complimentary-label' | translate }}
          </span>
        </label>
        <label>
          <input type="checkbox" [(ngModel)]="registration.Registration.DoNotInvoice" />
          <span>
            {{ 'events.registration.wizard.payment-info.do-not-invoice-label' | translate | titlecase }}
          </span>
        </label>
        <label
          [hidden]="registration.Registration.PaymentOptionFeeAmount <= 0 && registration.Registration.DoNotAddPaymentOptionFee != true"
        >
          <input
            type="checkbox"
            [(ngModel)]="registration.Registration.DoNotAddPaymentOptionFee"
            (ngModelChange)="onDoNotAddPaymentOptionFeeChange($event)"
          />
          <span>
            {{ 'events.registration.wizard.payment-info.do-not-add-payment-option-fee' | translate | titlecase }}
          </span>
        </label>
      </div>
    </div>

    <hr />

    <div
      [hidden]="
        (registration.IsEdit && registration.Registration.PaymentOptionForEdit != 3) ||
        (!registration.IsEdit && registration.Registration.PaymentOption != 3) ||
        registration.Registration.AdditionalPaymentAmountForEdit <= 0 ||
        (registration.IsEdit &&
          registration.ModificationOptions.DoNotModifyInvoice &&
          registration.Registration.AdditionalPaymentAmountForEdit == 0)
      "
    >
      <div class="form-group" [hidden]="hasCreditCardOnFileEnabled == false || this.registration.Registration.ProfileId <= 0">
        <div class="col-sm-offset-3 col-sm-9 col-md-4">
          <select [(ngModel)]="selectedCcPaymentProfileId" class="form-control" (ngModelChange)="onGatewayPaymentProfileChange($event)">
            <option *ngFor="let gatewayPaymentProfile of gatewayPaymentProfiles" [value]="gatewayPaymentProfile.CcPaymentProfileId">
              {{ gatewayPaymentProfile.CardNumber }}
            </option>
          </select>
        </div>
      </div>

      <div [hidden]="isSavedCardSelected(selectedGatewayPaymentProfile?.CcPaymentProfileId)">
        <wl-credit-card-input
          #creditCardInputComponent
          [(ngModel)]="registration.Registration.CreditCardPayment"
          [resolvedGateway]="resolvedGateway"
          fieldCellCssClass="col-sm-9 col-md-4"
        ></wl-credit-card-input>
      </div>

      <div class="col-sm-offset-3 col-sm-9" [hidden]="true">
        <input type="checkbox" [(ngModel)]="registration.Registration.SaveToCardOnFile" />
        {{ 'events.registration.wizard.payment-info.save-credit-card-label' | translate | titlecase }}
      </div>
    </div>

    <div
      class="form-group"
      [hidden]="
        (registration.IsEdit && registration.Registration.PaymentOptionForEdit != 4) ||
        (!registration.IsEdit && registration.Registration.PaymentOption != 4) ||
        registration.Registration.AdditionalPaymentAmountForEdit <= 0 ||
        (registration.IsEdit && registration.ModificationOptions.DoNotModifyInvoice)
      "
    >
      <label class="col-sm-6 col-md-3 control-label">
        {{ 'events.registration.wizard.payment-info.purchase-order-label' | translate | titlecase }}
      </label>
      <div class="col-sm-6 col-md-4">
        <input type="text" [(ngModel)]="registration.Registration.PO" class="form-control" />
      </div>
    </div>

    <div
      [hidden]="
        (registration.IsEdit && registration.Registration.PaymentOptionForEdit != 5) ||
        (!registration.IsEdit && registration.Registration.PaymentOption != 5) ||
        registration.Registration.AdditionalPaymentAmountForEdit <= 0 ||
        (registration.IsEdit &&
          registration.ModificationOptions.DoNotModifyInvoice &&
          registration.Registration.AdditionalPaymentAmountForEdit == 0)
      "
    >
      <div class="form-group">
        <div class="col-sm-6 col-md-3 control-label">
          {{ 'events.registration.wizard.payment-info.payment-type-label' | translate | titlecase }}
        </div>
        <div class="col-sm-6 col-md-4">
          <wl-payment-type-selector [(ngModel)]="registration.Registration.OverridePaymentypeId"> </wl-payment-type-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-6 col-md-3 control-label">
          {{ 'events.registration.wizard.payment-info.check-number-label' | translate | titlecase }}
        </label>
        <div class="col-sm-6 col-md-4">
          <input type="text" [(ngModel)]="registration.Registration.CheckNum" class="form-control" />
        </div>
      </div>
    </div>

    <div
      *ngIf="
        registration.IsEdit &&
        (registration.EditTotalAmountChanged ||
          registration.EditOriginalItemsChanged ||
          registration.EditNewItemsAdded ||
          registration.Registration.AdditionalPaymentAmountForEdit < 0 ||
          registration.Registration.PaymentOptionFeeAmount > 0 ||
          registration.Registration.InvoiceTotalDelta != 0)
      "
    >
      <div class="form-group" *ngIf="registration.IsEdit">
        <div class="col-sm-10 col-md-7">
          <h3>{{ 'events.registration.wizard.payment-info.modification-options-label' | translate | titlecase }}</h3>
          <p>{{ 'events.registration.wizard.payment-info.modification-options-instructions' | translate }}</p>
        </div>
      </div>
      <div class="form-group" *ngIf="registration.IsEdit">
        <div
          [ngClass]="{
            'col-sm-12': registration.ModificationOptions.DoNotModifyInvoice,
            'col-sm-offset-6 col-md-offset-3 col-sm-4': !registration.ModificationOptions.DoNotModifyInvoice,
          }"
        >
          <label
            [title]="
              registration.Registration.PaymentOptionForEdit == 3 ||
              registration.Registration.PaymentOptionForEdit == 4 ||
              registration.Registration.PaymentOptionForEdit == 5
                ? ('events.registration.wizard.payment-info.modification-options-do-not-modify-invoice-and-payment-not-mixable-msg'
                  | translate)
                : ''
            "
          >
            <input
              type="checkbox"
              data-cy="chkDoNotModifyInvoice"
              [(ngModel)]="registration.ModificationOptions.DoNotModifyInvoice"
              [disabled]="
                !registration.ModificationOptions.DoNotModifyInvoice &&
                (registration.Registration.PaymentOptionForEdit == 3 ||
                  registration.Registration.PaymentOptionForEdit == 4 ||
                  registration.Registration.PaymentOptionForEdit == 5)
              "
            />
            {{ 'events.registration.wizard.payment-info.modification-options-do-not-modify-invoice-label' | translate | ucfirst }}
          </label>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="
          registration.IsEdit &&
          registration.Registration.AdditionalPaymentAmountForEdit < 0 &&
          registration.ModificationOptions.DoNotModifyInvoice == false
        "
      >
        <div class="col-sm-offset-6 col-md-offset-3 col-sm-4" *ngIf="registration.Registration.PaymentOption == 3">
          <label>
            <input type="checkbox" [(ngModel)]="registration.ModificationOptions.RefundCreditCardPayments" />

            {{ 'events.registration.wizard.payment-info.modification-options-refund-credit-card-payments-label' | translate | titlecase }}
          </label>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="registration.IsEdit && originalAmountPaid > 0 && registration.ModificationOptions.DoNotModifyInvoice == false"
      >
        <label class="col-sm-6 col-md-3 control-label">
          {{ 'events.registration.wizard.payment-info.modification-options-payment-adjustment-type-label' | translate | titlecase }}
        </label>
        <div class="col-sm-4">
          <wl-adjustment-type-selector [(ngModel)]="registration.ModificationOptions.PaymentAdjustmentTypeId"></wl-adjustment-type-selector>
        </div>
      </div>
      <div
        class="form-group"
        *ngIf="
          registration.IsEdit &&
          (registration.EditTotalAmountChanged || this.registration.ItemsChanged || registration.Registration.InvoiceTotalDelta != 0) &&
          registration.ModificationOptions.DoNotModifyInvoice == false
        "
      >
        <label class="col-sm-6 col-md-3 control-label">
          {{ 'events.registration.wizard.payment-info.modification-options-invoice-adjustment-type-label' | translate | titlecase }}
        </label>
        <div class="col-sm-4">
          <wl-adjustment-type-selector [(ngModel)]="registration.ModificationOptions.InvoiceAdjustmentTypeId"></wl-adjustment-type-selector>
        </div>
      </div>
      <div class="form-group" *ngIf="registration.IsEdit && registration.ModificationOptions.DoNotModifyInvoice == false">
        <div class="col-sm-6 col-md-3 control-label">
          {{ 'events.registration.wizard.payment-info.modification-options-notes-label' | translate | titlecase }}
        </div>
        <div class="col-sm-4">
          <textarea class="form-control" [(ngModel)]="registration.ModificationOptions.Notes"></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
